import React from 'react';
import { cn } from '@frontend/shadcn/lib/utils';
import {
  HighlightTabRoot,
  HighlightTabHeading,
  HighlightTabInfo,
} from '@/shadcn/components/demographics/components/highlight-tab';

interface SocialStatsHighlightTabProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  isActive?: boolean;
  headingText: string;
  infoText: string;
  className?: string;
}

export const SocialStatsHighlightTab = React.forwardRef<
  HTMLButtonElement,
  SocialStatsHighlightTabProps
>(({ className, isActive, headingText, infoText, ...props }, ref) => {
  return (
    <HighlightTabRoot
      ref={ref}
      isActive={isActive}
      className={cn(
        'bg-white hover:bg-gray-50',
        isActive ? 'border-[#6C77DE]' : 'border-[#E5E8EB]',
        className,
      )}
      {...props}
    >
      <HighlightTabHeading>{headingText}</HighlightTabHeading>
      <HighlightTabInfo>{infoText}</HighlightTabInfo>
    </HighlightTabRoot>
  );
});

SocialStatsHighlightTab.displayName = 'SocialStatsHighlightTab';
